import { render, staticRenderFns } from "./DeniedRequest.vue?vue&type=template&id=edd14d8a&scoped=true"
import script from "./DeniedRequest.vue?vue&type=script&lang=js"
export * from "./DeniedRequest.vue?vue&type=script&lang=js"
import style0 from "./DeniedRequest.vue?vue&type=style&index=0&id=edd14d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd14d8a",
  null
  
)

export default component.exports